require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es7.symbol.observable.js
// module id = 384
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11